import React, { useEffect, useState, useRef } from 'react'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const Opentimelinemodal = ({
  show,
  onClose,
  onImagetimeline,
  onSubmitpost, 
  fetchinputs,
  inputData
}) => {
  const [file, setFile] = useState(null)
  const [text, setText] = useState('')
  const [project, setProject] = useState('')
  const [wing, setWing] = useState('')
  const [filteredWings, setFilteredWings] = useState([])

  const [projectError, setProjectError] = useState('')
  const [wingError, setWingError] = useState('')
  const [fileError, setFileError] = useState('')
  const [textError, setTextError] = useState('')
  const [loading, setLoading] = useState(false)

  const fileInputRef = useRef(null)

  useEffect(() => {
    console.log('Modal inputData updated:', inputData)
  }, [inputData])

  if (!show) return null

  const uniqueProjects = Array.from(
    new Map(
      inputData.map(item => [
        item.projectId,
        { id: item.projectId, name: item.projectName }
      ])
    ).values()
  )


  const handleProjectChange = e => {
    const selectedProjectId = e.target.value
    setProject(selectedProjectId)
    setProjectError('')
    setWing('')

    const wings = inputData.filter(
      item => String(item.projectId) === String(selectedProjectId)
    )

    setFilteredWings(wings)
  }

  const handleWingChange = e => {
    setWing(e.target.value)
    if (e.target.value) setWingError('')
  }


  const validatefile = e => {
    const selectedFile = e.target.files[0]
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']

    if (!selectedFile || !allowedTypes.includes(selectedFile.type)) {
      setFile(null)
      setFileError('Please upload JPEG or PNG image only.')
      return
    }

    setFile(selectedFile)
    setFileError('')
  }

 
  const validatetext = input => {
    setText(input)
    if (!input || input.trim() === '') {
      setTextError('Text input cannot be empty.')
      return false
    } else {
      setTextError('')
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()

    let valid = true

    if (!project) {
      setProjectError('Project is required')
      valid = false
    }

    if (!wing) {
      setWingError('Wing is required')
      valid = false
    }

    if (!file) {
      setFileError('Image is required')
      valid = false
    }

    if (!text.trim()) {
      setTextError('Text is required')
      valid = false
    }

    if (!valid) return

    setLoading(true)

    try {
      const formData = new FormData()
      formData.append('upload', file)

      const uploadRes = await onImagetimeline(formData)

      const payload = {
        ProjectID: parseInt(project),
        Wing: wing,
        Data: {
          Title: text,
          ImageLink: uploadRes
        }
      }

      await onSubmitpost(payload)


      setFile(null)
      setText('')
      setProject('')
      setTextError('')

      setWing('')
      setFilteredWings([])
      if (fileInputRef.current) fileInputRef.current.value = ''

      onClose()
    } catch (err) {
      toast.error('Failed to submit post')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div
        className="modal-backdrop show"
        style={{
          backgroundColor: 'rgba(255,255,255,0.1)',
          backdropFilter: 'blur(20px)'
        }}
      />

      <div className="modal fade show d-block">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title text-bold fs-3">Add new post to timeline</h5>
                <button type="button" className="btn-close" onClick={onClose} />
              </div>

              <div className="modal-body">
                <div className="mb-3 text-bold">
                  <label className="form-label">
                    Select Project <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={project}
                    onChange={handleProjectChange}
                  >
                    <option value="">Choose Project</option>
                    {uniqueProjects.map(p => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                  {projectError && (
                    <div className="alert alert-danger mt-2">
                      {projectError}
                    </div>
                  )}
                </div>

                {/* WING */}
                <div className="mb-3">
                  <div className="mb-3 text-bold">
                  <label className="form-label">
                    Select Wing <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={wing}
                    onChange={handleWingChange}
                    disabled={!project}
                  >
                    <option value="">Choose Wing</option>
                    {filteredWings.map(w => (
                      <option key={w.wingId} value={w.wingName}>
                        {w.wingName}
                      </option>
                    ))}
                  </select>
                  {wingError && (
                    <div className="alert alert-danger mt-2">{wingError}</div>
                  )}
                </div>
                </div>
                <div className="mb-3">
                  <label className="form-label text-bold">
                    Upload Image <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/gif"
                    className="form-control"
                    onChange={validatefile}
                    ref={fileInputRef}
                  />
                  {fileError && (
                    <div className="alert alert-danger mt-2">{fileError}</div>
                  )}
                </div>

                {/* TEXT */}
                <div className="mb-3 text-bold">
                    <label className="form-label font-bold">Enter Text</label>{' '}
                    <span style={{ color: 'red' }}>*</span>
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Enter text"
                      maxlength="1000"
                      value={text}
                      onChange={e => validatetext(e.target.value)}
                      required
                    />
                  </div>
                  {textError && (
                    <div className="alert alert-danger mt-2">{textError}</div>
                  )}
                </div>

              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default Opentimelinemodal
